<template>
  <div class="edu-testimonial-area ptb-100">
    <div class="container">
      <div class="row justify-content-center">
        <!-- Ali Çoban -->
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="edu-review">
            <div class="content">
              <p class="quote">“Benim için gerçekten en iyi çözüm oldu”</p>
              <p>
                Eğitim süreci boyunca hem teorik hem de pratik bilgiler edindim.
                Kariyerimde yeni bir bakış açısı kazandırdı.
              </p>
              <ul class="ratings">
                <li><i class="bx bxs-star"></i></li>
                <li><i class="bx bxs-star"></i></li>
                <li><i class="bx bxs-star"></i></li>
                <li><i class="bx bxs-star"></i></li>
                <li><i class="bx bxs-star"></i></li>
              </ul>
              <h3>Ali Çoban</h3>
              <span>Yazılım Geliştirici</span>
            </div>
          </div>
        </div>

        <!-- Ayşe Yılmaz -->
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="edu-review">
            <div class="content">
              <p class="quote">“Eğitmenlerimizden en iyi tavsiyeleri aldım”</p>
              <p>
                Ders içerikleri anlaşılır, destek ekibi her zaman yanımdaydı.
                Çok faydalı ve keyifli bir eğitim süreciydi.
              </p>
              <ul class="ratings">
                <li><i class="bx bxs-star"></i></li>
                <li><i class="bx bxs-star"></i></li>
                <li><i class="bx bxs-star"></i></li>
                <li><i class="bx bxs-star"></i></li>
                <li><i class="bx bxs-star"></i></li>
              </ul>
              <h3>Ayşe Yılmaz</h3>
              <span>UI/UX Tasarımcı</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Ortak Başlık -->
      <div class="row">
        <div class="col-lg-12 text-center mt-5">
          <div class="edu-testimonial-content">
            <p class="sub-title">Katılımcı Yorumu</p>
            <h2>
              <span class="shape02">Öğrencilerimizden</span> Değerli Yorumlar
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TestimonialContent",
};
</script>

<style scoped>
.edu-review {
  background: #fff;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  text-align: center;
  margin-bottom: 30px;
}

.edu-review .quote {
  font-size: 18px;
  font-weight: 600;
  color: #000;
  margin-bottom: 10px;
}

.edu-review p {
  font-size: 15px;
  color: #666;
}

.edu-review h3 {
  font-size: 17px;
  font-weight: 700;
  margin-top: 15px;
  margin-bottom: 5px;
}

.edu-review span {
  font-size: 14px;
  color: #f44336;
}
</style>
